import router from '../src/router'
import { GlobalActions } from '../../../enums/globa'
import { useReuseTabStore } from '@/store/reuse-tab'
import { useLoadingStore } from '@/store/loading'
import pinia from '@/store'
import { message } from 'ant-design-vue'
import { useUserStore } from '@/store/user'
import { useMenuStore } from '@/store/menu'
import {
  HALL_PRO_PUBLIC_PATH,
  HALL_APP_NAME,
  HALL_ACTIVE_RULE,
  MANAGER_APP_NAME,
  MANAGER_ACTIVE_RULE,
  MANAGER_DEV_PORT,
  HALL_DEV_PORT,
  MANAGER_PRO_PUBLIC_PATH,
  SYSTEM_APP_NAME,
  SYSTEM_PRO_PUBLIC_PATH,
  SYSTEM_ACTIVE_RULE,
  SYSTEM_DEV_PORT,
  EXPERT_APP_NAME,
  EXPERT_PRO_PUBLIC_PATH,
  EXPERT_ACTIVE_RULE,
  EXPERT_DEV_PORT,
  BIGSCREEN_APP_NAME,
  BIGSCREEN_PRO_PUBLIC_PATH,
  BIGSCREEN_ACTIVE_RULE,
  BIGSCREEN_DEV_PORT,
  REPORT_APP_NAME,
  REPORT_PRO_PUBLIC_PATH,
  REPORT_ACTIVE_RULE,
  REPORT_DEV_PORT,
} from '../../../micro/micro-config.js'
import { useTokenStore } from '@/store/token'
import { useClientStore } from '@/store/client'
import { useMixAuthStore } from '@/store/mix-auth'

const reuseTabStore = useReuseTabStore(pinia)
const lodingStore = useLoadingStore(pinia)
const userStore = useUserStore(pinia)
const menuStore = useMenuStore(pinia)
const tokenStore = useTokenStore(pinia)
const clientStore = useClientStore(pinia)
const mixAuthStore = useMixAuthStore(pinia)

// 唤起在线客服窗口
export const openCustomerService = () => {
  const serviceBtn = document.querySelector('#YSF-BTN-HOLDER')
  if (serviceBtn) {
    serviceBtn.dispatchEvent(new Event('click'))
  } else {
    message.error('在线客服系统唤起失败！请稍后再试！')
  }
}

export const state = {
  userInfo: {},
  token: '',
  action: GlobalActions.None,
  loading: false,
  menus: [],
  originalMenus: [],
  reuseTabSource: [],
  buttons: [],
  clients: [],
  currentClient: [],
  mixAuthUserName: '',
  mixAuthToken: '',
  mixAuthModules: [],
}

export const commonProps = {
  parentRouter: router as any,
  state,
  reuseTabStore,
  lodingStore,
  userStore,
  menuStore,
  openCustomerService,
  tokenStore,
  clientStore,
  mixAuthStore,
}
export const apps = [
  {
    name: HALL_APP_NAME, //子应用的名称
    entry: process.env.NODE_ENV === 'production' ? HALL_PRO_PUBLIC_PATH : `//localhost:${HALL_DEV_PORT}`, //子应用的域名
    container: '#hall-micro-container', //承载子应用的容器，在上面App.vue中定义
    activeRule: HALL_ACTIVE_RULE, // 被激活的子应用的路由
    props: {
      baseRoute: HALL_ACTIVE_RULE,
      ...commonProps,
    },
  },
  {
    name: MANAGER_APP_NAME,
    entry: process.env.NODE_ENV === 'production' ? MANAGER_PRO_PUBLIC_PATH : `//localhost:${MANAGER_DEV_PORT}`,
    container: '#micro-container',
    activeRule: MANAGER_ACTIVE_RULE,
    props: {
      baseRoute: MANAGER_ACTIVE_RULE,
      ...commonProps,
    },
  },
  {
    name: SYSTEM_APP_NAME,
    entry: process.env.NODE_ENV === 'production' ? SYSTEM_PRO_PUBLIC_PATH : `//localhost:${SYSTEM_DEV_PORT}`,
    container: '#micro-container',
    activeRule: SYSTEM_ACTIVE_RULE,
    props: {
      baseRoute: SYSTEM_ACTIVE_RULE,
      ...commonProps,
    },
  },
  {
    name: EXPERT_APP_NAME,
    entry: process.env.NODE_ENV === 'production' ? EXPERT_PRO_PUBLIC_PATH : `//localhost:${EXPERT_DEV_PORT}`,
    container: '#micro-container',
    activeRule: EXPERT_ACTIVE_RULE,
    props: {
      baseRoute: EXPERT_ACTIVE_RULE,
      ...commonProps,
    },
  },
  {
    name: BIGSCREEN_APP_NAME,
    entry: process.env.NODE_ENV === 'production' ? BIGSCREEN_PRO_PUBLIC_PATH : `//localhost:${BIGSCREEN_DEV_PORT}`,
    container: '#micro-container',
    activeRule: BIGSCREEN_ACTIVE_RULE,
    props: {
      baseRoute: BIGSCREEN_ACTIVE_RULE,
      ...commonProps,
    },
  },
  {
    name: REPORT_APP_NAME, //子应用的名称
    entry: process.env.NODE_ENV === 'production' ? REPORT_PRO_PUBLIC_PATH : `//localhost:${REPORT_DEV_PORT}`, //子应用的域名
    container: '#micro-container', //承载子应用的容器，在上面App.vue中定义
    activeRule: REPORT_ACTIVE_RULE, // 被激活的子应用的路由
    props: {
      baseRoute: REPORT_ACTIVE_RULE,
      ...commonProps,
    },
  },
]

function removeTrailingSlash(str: string) {
  return str.endsWith('/') ? str.slice(0, -1) : str
}

// USBKey控件
const hallEntry =
  process.env.NODE_ENV === 'production'
    ? `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ``
      }${HALL_PRO_PUBLIC_PATH}`
    : `${window.location.protocol}//localhost:${HALL_DEV_PORT}`
const usbKeyPluginPath = [`${removeTrailingSlash(hallEntry)}/USBKey_js/mToken.js`]

const excludeAsserts = ['https://qiyukf.com', 'amap.com', ...usbKeyPluginPath]
export function excludeAssetFilter(url) {
  return excludeAsserts.includes(url)
}
